import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-10 md:gap-12',
    list: 'flex flex-col gap-12 md:gap-20',
    loadMoreButton:
      'bg-bg-items-white heading-s-bold mt-12 flex h-12.5 w-full cursor-pointer items-center justify-center uppercase'
  }
});
